import { render, staticRenderFns } from "./SubmitCustomContent.vue?vue&type=template&id=37bfdffb&scoped=true"
import script from "./SubmitCustomContent.vue?vue&type=script&lang=js"
export * from "./SubmitCustomContent.vue?vue&type=script&lang=js"
import style0 from "./SubmitCustomContent.vue?vue&type=style&index=0&id=37bfdffb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bfdffb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37bfdffb')) {
      api.createRecord('37bfdffb', component.options)
    } else {
      api.reload('37bfdffb', component.options)
    }
    module.hot.accept("./SubmitCustomContent.vue?vue&type=template&id=37bfdffb&scoped=true", function () {
      api.rerender('37bfdffb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FinanceVer2/managePackages/components/dialog/SubmitCustomContent.vue"
export default component.exports